/* 
PUBLIC PAGE 
*/
import React from "react";
import RegisterForm from "../Components/RegisterForm/RegisterForm";
import Layout from "../Components/Layout/Layout";

function RegisterPage() {
    return (
    <Layout>
      <RegisterForm />
    </Layout>
    )
}

export default RegisterPage;